import AuthInfoMgmt from 'iceqerp-common/auth-info-mgmt';
import apiProxy from './apis/api-proxy-inst';
import authApi from './apis/auth-api';

class MyAuthInfoMgmt extends AuthInfoMgmt {
  constructor() {
    super({ name: 'TM_ADMIN' });
  }

  init() {
    this.load();

    if (!this.isSignedIn()) {
      return Promise.resolve();
    }

    apiProxy.setCertificate(this.getCertificate());

    return authApi
      .renew()
      .then(data => {
        super.signIn(data);
      }).catch(() => {
        this.signOut();
      });
  }

  signIn(args) {
    return authApi
      .signIn(args)
      .then((data) => {
        if (data.succeeded) {
          super.signIn(data);
        }
        return data;
      });
  }

  ChangePassWord(args) {
    return authApi
      .changePassword(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  signOut() {
    apiProxy.clearCertificate();
    super.signOut();
  }
}

export default new MyAuthInfoMgmt();